import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllCadastroCoresUseCase } from "../../../presentation/useCases/read/get_all_cadastro_cores_use_case";
import { CadastroCores } from "../../models/cadastro_cores";
import { IEquipamentoMedicaoRepository } from "../../repositories/EquipamentoMedicao_Repositorie";

/**
 * GetAllCadastroCoresUseCase
 */

export class GetAllCadastroCoresUseCase
  extends BasePaginatedUseCase<CadastroCores>
  implements IGetAllCadastroCoresUseCase {
  constructor(private readonly repository: IEquipamentoMedicaoRepository) {
    super();
  }

  async getAllCadastroCores(
    cor: string | null,
    dataDe: Date | null,
    dataAte: Date | null,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const response = await this.repository.getAllCadastroCores(
      cor,
      dataDe,
      dataAte,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._totalPages = response.totalPages;
    this._totalItems = response.totalItems;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
  }
}
